import { IStudent } from '@wot/typings';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../../components/Table';
import { TableRowItem } from './TableRowItem';
import { useNavigate } from 'react-router-dom';
import { BiSort } from 'react-icons/bi';
import { ISorting } from '..';

interface Props {
  data: IStudent[];
  handleSort?: (key: ISorting) => void;
}

export default function TableContainer({ data, handleSort }: Props) {
  const navigate = useNavigate();
  return (
    <Table>
      <TableHeading>
        <TableRow>
          <TableHeadingCol
            onClick={() => handleSort && handleSort('createdAt')}
            label="Date"
            component={
              <div className="flex items-center">
                <p className="">Date</p>
                <BiSort className="text-sm" />
              </div>
            }
          />
          <TableHeadingCol label="STUDENT ID" />
          <TableHeadingCol label="NAME" />
          <TableHeadingCol label="EMAIL" />
          <TableHeadingCol label="PHONE NO." />
          <TableHeadingCol label="STATUS" />
        </TableRow>
      </TableHeading>
      <TableBody>
        {data.map((student) => (
          <TableRow key={student._id} onClick={() => navigate(`${student._id}`)}>
            <TableRowItem student={student} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
